"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Panel = _ref => {
  let {
    color,
    children,
    className,
    hasBackground,
    hasBorder,
    hasBorderTop,
    borderTopColor,
    hasPanelBlockBorder,
    hasHeadingBorder,
    hasTitleBorder,
    customBackgroundClassName,
    hasRoundedCorners,
    heading,
    headingSize,
    headingColor,
    headingAlign,
    title,
    titleSize,
    titleColor,
    titleAlign,
    isNarrow,
    renderAs
  } = _ref;
  const classNames = (0, _classnames.default)({
    'is-narrow': isNarrow,
    'with-border': hasBorder,
    'with-border-top': hasBorderTop || borderTopColor,
    [`has-border-top-${borderTopColor}`]: borderTopColor,
    'with-no-border-radius': !hasRoundedCorners,
    'with-background': hasBackground,
    'with-no-panel-block-border': !hasPanelBlockBorder,
    [customBackgroundClassName]: customBackgroundClassName,
    [`is-${color}`]: color
  });
  const headerClassNames = (0, _classnames.default)({
    'with-border': hasHeadingBorder || hasTitleBorder,
    [`is-size-${headingSize || titleSize}`]: headingSize || titleSize,
    [`has-text-${headingColor || titleColor}`]: headingColor || titleColor,
    [`has-text-${headingAlign || titleAlign}`]: headingAlign || titleAlign
  });
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('panel', className, classNames) || undefined
  }, (heading || title) && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)('panel-heading', headerClassNames) || undefined
  }, heading || title), children);
};
Panel.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  className: _propTypes.default.string,
  customBackgroundClassName: _propTypes.default.string,
  isNarrow: _propTypes.default.bool,
  hasBackground: _propTypes.default.bool,
  hasBorder: _propTypes.default.bool,
  hasRoundedCorners: _propTypes.default.bool,
  hasBorderTop: _propTypes.default.bool,
  borderTopColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text', 'secondary', 'cyan', 'blue', 'sky', 'grape', 'teal', 'green', 'berry', 'rose', 'blue-light', 'sky-light', 'grape-light', 'teal-light', 'green-light', 'berry-light', 'rose-light', 'blue-dark', 'sky-dark', 'grape-dark', 'teal-dark', 'green-dark', 'berry-dark', 'rose-dark']), _propTypes.default.string]),
  hasPanelBlockBorder: _propTypes.default.bool,
  heading: _propTypes.default.string,
  headingSize: _propTypes.default.number,
  headingColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text']), _propTypes.default.string]),
  headingAlign: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'left', 'right', 'center']), _propTypes.default.string]),
  title: _propTypes.default.string,
  titleSize: _propTypes.default.number,
  titleColor: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text']), _propTypes.default.string]),
  titleAlign: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'left', 'right', 'center']), _propTypes.default.string]),
  hasHeadingBorder: _propTypes.default.bool,
  hasTitleBorder: _propTypes.default.bool,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text']), _propTypes.default.string]),
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Panel.defaultProps = {
  color: 'white',
  className: '',
  hasBackground: true,
  hasRoundedCorners: false,
  hasPanelBlockBorder: true,
  hasBorder: false,
  hasBorderTop: false,
  hasTitleBorder: true,
  renderAs: 'article'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Panel);
//# sourceMappingURL=Panel.js.map